import { useTranslation } from "react-i18next";
import { Alert, Box, Button, Stack } from "@schaeffler-commerce/design-system";
import { resolveAsmMessage } from "~/features/assistedService/utils/asmMessage";

interface Props {
  pending: boolean;
  alert: { messageCode: string; alertClass: string | null } | null;
  onLogin: () => void;
  className?: string;
  sx?: object;
}

/**
 * ASM agent login trigger (task 0250 lane 2a): the agent's credentials go to
 * the authorization server's own login page via the `schaeffler-asm`
 * authorization_code + PKCE redirect — the storefront never sees them, so
 * this form is a single sign-in action, not a credential form.
 */
export const AsmLoginForm = ({ pending, alert, onLogin, className, sx }: Props) => {
  const { t } = useTranslation();

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    if (pending) {
      return;
    }
    onLogin();
  };

  return (
    <Stack className={className} sx={sx} component="form" onSubmit={submit} spacing={2}>
      {alert && <Alert severity="error">{resolveAsmMessage(t, alert.messageCode)}</Alert>}
      <Stack direction={{ phone: "column", tablet: "row" }} spacing={2} sx={{ alignItems: "center" }}>
        <Box>
          <Button type="submit" variant="contained" disabled={pending}>
            {t("asm.login.submit")}
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
};
